// removed by extract-text-webpack-plugin
module.exports = {"root":"_2TDCKFuVxvEwUM7mA12rip","title":"_5T8NHCef3s8h53Krxd0wS","type-success":"XQjOi-HUujJs_WkmvE6dB","type-warning":"_1M_Nquj6kCgUSnTy334sdK","button-container":"XThF5MySiXXSHH7nscazZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/alert.scss
// module id = 1300
// module chunks = 0